const ItemStyle = {
  default: {},
  TreeCircleStyle: function (latlng, fillColor = "#00ff00", properties) {
    // if stem_radius is null or NaN, use default value
    if (isNaN(properties.stem_radius)) {
      properties.stem_radius = 0.5;
    }

    if (properties.felled_tree) {
      fillColor = "#f90000";
      return L.circle(latlng, {
        fillColor: fillColor,
        color: fillColor,
        weight: 0,
        opacity: 1,
        fillOpacity: 0.5,
        radius: 1.5, // Raggio dell'area attiva per il popup

        pmIgnore: true,
        snapIgnore: true,
      });
    } else {
      if (properties.at_risk) {
        fillColor = "#dd6600";
      }

      let stem = L.circle(latlng, {
        fillColor: fillColor,
        color: fillColor,
        weight: 1,
        opacity: 1,
        fillOpacity: 1,
        radius: properties.stem_radius ? properties.stem_radius / 100 : 0.5,
        pmIgnore: true,
        snapIgnore: true,
      });

      let hitbox = L.circle(latlng, {
        fillColor: fillColor,
        color: fillColor,
        weight: 0,
        opacity: 1,
        fillOpacity: 0.5,
        radius: 1.5, // Raggio dell'area attiva per il popup

        pmIgnore: true,
        snapIgnore: true,
      });

      return L.featureGroup([hitbox, stem]);
    }
  },
};

window.ItemStyle = ItemStyle;
